var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", [_c("Header", [_c("MenuBar"), _c("User")], 1)], 1),
      _c("el-main", { class: _vm.pageName }, [_vm._t("default")], 2),
      _c("el-footer", [_c("Footer")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }